/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import '../../../services/transfer/create_transfer';
import './list_estimated_transfer_events';
import './list_transactions';
import './retrieve_transaction_details';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "TransferService": {
                    "methods": {
                      "CreateTransfer": {
                        "requestType": "squareup.sfs.service.CreateTransferRequest",
                        "responseType": "squareup.sfs.service.CreateTransferResponse"
                      },
                      "ListEstimatedTransferEvents": {
                        "requestType": "squareup.sfs.external.service.ListEstimatedTransferEventsRequest",
                        "responseType": "squareup.sfs.external.service.ListEstimatedTransferEventsResponse"
                      },
                      "ListTransactions": {
                        "requestType": "squareup.sfs.external.service.ListTransactionsRequest",
                        "responseType": "squareup.sfs.external.service.ListTransactionsResponse"
                      },
                      "RetrieveTransactionDetails": {
                        "requestType": "squareup.sfs.external.service.RetrieveTransactionDetailsRequest",
                        "responseType": "squareup.sfs.external.service.RetrieveTransactionDetailsResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.TransferService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPCs for transfering funds, and listing transactions
 * --
 *
 * SOURCE TransferService @ squareup/sfs/external/services/transfer/transfer_service.proto at 14:1
 */
export const TransferService = $root.lookupService('squareup.sfs.external.service.TransferService');